var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 7.91683C9.5275 7.91683 10.8333 6.61099 10.8333 5.00016C10.8333 3.38933 9.5275 2.0835 7.91667 2.0835C6.30584 2.0835 5 3.38933 5 5.00016C5 6.61099 6.30584 7.91683 7.91667 7.91683Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 17.4998V11.6665M11.25 14.5832H17.0833",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.4165V13.7252C2.5 12.6899 2.96606 11.6748 3.90807 11.2453C5.05708 10.7216 6.4351 10.4165 7.91667 10.4165C8.79508 10.4165 9.63717 10.5238 10.4167 10.7203",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRole);
export default __webpack_public_path__ + "static/media/add_role.322467d38583fbaf174abb80af06e87e.svg";
export { ForwardRef as ReactComponent };